import { Injectable } from '@angular/core';
import { Log } from 'src/app/core/console.log';
import { ScreenName } from 'src/app/shared/display/screen.name';
import { screenSize } from '../../config/constants';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  setScreen(w: number, h: number): void {
    Log.debug('w: ' + w, 'h: ' + h);
  }

  checkSizeScreen(w: number): ScreenName {
    if (this.isBetweenMinMax(screenSize[ScreenName.extraSmall], w)) {
      return ScreenName.extraSmall;
    } else if (this.isBetweenMinMax(screenSize[ScreenName.smallDevices], w)) {
      return ScreenName.smallDevices;
    } else if (this.isBetweenMinMax(screenSize[ScreenName.mediumDevices], w)) {
      return ScreenName.mediumDevices;
    } else if (this.isBetweenMinMax(screenSize[ScreenName.largeDevices], w)) {
      return ScreenName.largeDevices;
    } else {
      return ScreenName.extraLarge;
    }
  }

  private isBetweenMinMax(size: { min, max }, val: number) {
    return size.min <= val && val <= size.max;
  }
}
